import { TypographyOptions } from '@material-ui/core/styles/createTypography'
import { Breakpoints } from '@material-ui/core/styles/createBreakpoints'

const typography = (breakpoints: Breakpoints): TypographyOptions => ({
  fontFamily:
    '"Rubik Variable", "Rubik", "Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 16,
  h1: {
    fontSize: '3.125rem',
    fontWeight: 700
  },
  h2: {
    fontSize: '2.8rem',
    fontWeight: 700
  },
  h3: {
    fontSize: '2.5rem',
    fontWeight: 600,
    [breakpoints.only('xs')]: {
      fontSize: '1.6rem'
    }
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 600
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 500
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 400,
    [breakpoints.only('lg')]: {
      fontSize: '1.1rem'
    },
    [breakpoints.up('xl')]: {
      fontSize: '1.1rem'
    },
    '@media (min-width:2570px)': {
      fontSize: '1.4rem'
    }
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400
  },
  body2: {
    fontSize: '0.9rem',
    fontWeight: 400,
    [breakpoints.only('xl')]: {
      fontSize: '1rem'
    }
  }
})

export default typography
